export const STAGES = ["New", "Contacted", "Qualified", "Proposal Sent", "Won", "Lost"];

export const STAGE_STYLES = {
  New: { text: "#60A5FA", border: "#3B82F6", bg: "rgba(59,130,246,0.1)" },
  Contacted: { text: "#A78BFA", border: "#8B5CF6", bg: "rgba(139,92,246,0.1)" },
  Qualified: { text: "#FBBF24", border: "#F59E0B", bg: "rgba(245,158,11,0.1)" },
  "Proposal Sent": { text: "#FB923C", border: "#F97316", bg: "rgba(249,115,22,0.1)" },
  Won: { text: "#34D399", border: "#10B981", bg: "rgba(16,185,129,0.1)" },
  Lost: { text: "#F87171", border: "#EF4444", bg: "rgba(239,68,68,0.1)" },
};

export const INDUSTRIES = [
  "Law Firm",
  "Medical Clinic",
  "Dental Office",
  "Accounting Firm",
  "Real Estate",
  "Manufacturing",
  "Retail",
  "Non-Profit",
  "Education",
  "Government",
  "Technology",
  "Construction",
  "Hospitality",
  "Other",
];

export const COMPANY_SIZES = ["1-10", "11-50", "51-200", "201-500", "500+"];

export const LEAD_SOURCES = [
  "Referral",
  "Website",
  "Cold Outreach",
  "LinkedIn",
  "Event / Networking",
  "Google Search",
  "Existing Client",
  "Other",
];

export const fmtCurrency = (v) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD", maximumFractionDigits: 0 }).format(v || 0);
